import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { addedByEduToolsFilters, basicToolsFilters, getSchoolToolsFilters } from "../../../shared/utils/entitiesFiltersUtils";
import { mapToolsForDisplay } from "../../../shared/utils/toolDisplayUtils";
import { usePermission } from "../../../shared/hooks/usePermission";
import { openInNewTab } from "../../../shared/utils/utils";
import ToolsList from "../../../shared/components/features/toolsList/ToolsList";
import Page from "../../../shared/components/ui/page/Page";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import pathRouts from "../../../shared/enums/pathRoute";
import classes from "./UsefulToolsPage.module.css";

const UsefulToolsPage = () => {

    const { lang, texts } = useSelector(state => state.translate)
    const navigate = useNavigate();
    const { general } = useSelector(state => state.uiData);
    const { isStudent, userDetails } = useSelector(state => state.auth);
    const schoolToolsFilters = useMemo(() => getSchoolToolsFilters(isStudent, userDetails?.defaultSchool?.id), [isStudent, userDetails?.defaultSchool?.id]);
    const basicTools = useSelector((state) => selectEntitiesByFilters(state, basicToolsFilters));
    const addedByEdu = useSelector((state) => selectEntitiesByFilters(state, addedByEduToolsFilters));
    const schoolTools = useSelector((state) => selectEntitiesByFilters(state, schoolToolsFilters));
    const hasPermission = usePermission();

    return (
        <Page title={texts.usefulTools} icon={iconsList.usefulTools} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.UsefulToolsPage}>
                <p className={classes.UsefulToolsTitle}>{texts.usefulTools}</p>
                <ToolsList className={classes.MyToolsList} tools={mapToolsForDisplay(basicTools?.filter(tool => hasPermission(tool.visibleTo)), lang)} />
                <ToolsList className={classes.educationToolsList} text={texts.educationTools} tools={mapToolsForDisplay(schoolTools, lang)} />
                <ToolsList className={`${classes.recommendedToolsList} ${classes.ToolsListMinistryOfEducation}`} text={texts.recommendedToolsMinistryOfEducation} tools={mapToolsForDisplay(addedByEdu?.filter(tool => hasPermission(tool.visibleTo)), lang)} link={general.usefulToolsLinkForStudent} textLink={texts.catalogTools} />
            </div>
            <p className={classes.CatalogToolsLink} onClick={() => { openInNewTab(general.usefulToolsLinkForStudent) }}>{texts.catalogTools}</p>
        </Page>

    );
};

export default UsefulToolsPage;
